import React from "react";
import { Grid, Skeleton } from "@mui/material";
import { Container, IconInfoContainer, TitleDescriptionContainer, Title, Description } from "./styles";

interface Props {
  title?: string;
  description?: string;
  Icon: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
  IconStyle?: React.SVGAttributes<SVGElement>;
  titleStyle?: React.CSSProperties;
  customStyle?: React.CSSProperties;
  endAdornment?: JSX.Element;
  loading?: boolean;
}
const IconAndTitleContainer = ({
  title,
  description,
  Icon,
  IconStyle,
  titleStyle,
  customStyle,
  endAdornment,
  loading,
}: Props) => {
  return (
    <Container style={{ ...customStyle }}>
      <IconInfoContainer>
        <Icon {...IconStyle} />
        <TitleDescriptionContainer>
          <Title style={{ ...titleStyle }}>{title}</Title>
          <Description variant="body2">{description}</Description>
        </TitleDescriptionContainer>
      </IconInfoContainer>
      {loading ? (
        <Skeleton
          variant="rounded"
          width={"20px"}
          style={{
            display: "inline",
          }}
        />
      ) : (
        endAdornment
      )}
    </Container>
  );
};
export default IconAndTitleContainer;
